export const scrollToSection = (hash: string) => {
  if (hash) {
    const element = document.querySelector(hash);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }
};

export const handleHashScroll = () => {
  const hash = window.location.hash;
  if (hash) {
    // Small delay to ensure the page is fully loaded
    setTimeout(() => {
      scrollToSection(hash);
    }, 100);
  }
};
